import Vue from 'vue'

export let accessDeniedToaster = (callback, params) => {
  Vue.$toast.error('You do not have permission to view this resource, please contact your supervisor to request access.')
  callback(params)
}